import { useEffect, useState } from 'react';

/**
 * `value`, once it has held still for `delayMs`: rapid changes (typing, a
 * dragged control) coalesce into the one that stays.
 *
 * @param {T} value - The value to settle (memoize objects upstream)
 * @param {number} delayMs - How long it has to hold still
 * @return {T} The settled value
 */
export const useSettledValue = <T>(value: T, delayMs: number): T => {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
};
